import React from "react";
import { TextToolTip } from "../textToolTip";
import { Svg } from "assets";

export const DeleteActionBtn = ({ onClick }) => {
  return (
    <TextToolTip
      placement="top"
      arrow
      wrapperStyles={{
        width: "fit-content",
        height: "fit-content",
      }}
      classNameText="table-single-action-wrapper"
      showTooltip
      content="delete"
      onClick={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onClick(e);
      }}
      text={<Svg.TrashSvg />}
    />
  );
};
